import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";

export default function ProtectedRoute() {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="font-heading text-ink text-lg tracking-tight">a moment…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/signin" replace />;
    return (
        <Layout>
            <Outlet />
        </Layout>
    );
}
